module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/gastos/gastos-detallados/gastos-detallados.component.scss
// module id = ./src/app/gastos/gastos-detallados/gastos-detallados.component.scss
// module chunks = main